import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Helmet } from 'react-helmet';

import * as actions from '../actions';
import MainContent from './common/MainContent';
import ProjectCard from './common/ProjectCard';

class Projects extends Component {
	state = {};

	render() {
		const { projects } = this.props;
		return (
			<MainContent>
				<Helmet>
					<title>George Kanchev: Projects</title>
					<meta name="description" content={'List of some of my projects'} />
				</Helmet>
				<div className="row mt-3 mb-5 d-flex flex-column align-items-center justify-content-center">
					<div className="col-md-12 text-center">
						<h1>Projects</h1>
						<p>
							Majority of the projects I've worked on are private and I'd rather not disclose specifics. Most images are
							purely for flavour.
						</p>
						<div style={{ fontSize: '2rem', marginTop: '3rem' }} className="mainTechIcons">
							<span className="icon-react mainSpan" />
							<span className="icon-redux mainSpan" />
							<span className="icon-nodejs mainSpan">
								<span className="path1" />
								<span className="path2" />
								<span className="path3" />
								<span className="path4" />
								<span className="path5" />
								<span className="path6" />
							</span>
							<span className="icon-mysql mainSpan">
								<span className="path1" />
								<span className="path2" />
								<span className="path3" />
								<span className="path4" />
							</span>
							<span className="icon-lambda mainSpan" />
							<span className="icon-dynamodb mainSpan">
								<span className="path1" />
								<span className="path2" />
								<span className="path3" />
								<span className="path4" />
								<span className="path5" />
							</span>
							<span className="icon-s3 mainSpan" />
						</div>
						<div style={{ fontSize: '1.5rem', marginTop: '30px' }} className="mainTechIcons">
							<span className="icon-route53 mainSpan">
								<span className="path1" />
								<span className="path2" />
								<span className="path3" />
								<span className="path4" />
								<span className="path5" />
								<span className="path6" />
								<span className="path7" />
								<span className="path8" />
							</span>
							<span className="icon-cloudfront mainSpan">
								<span className="path1" />
								<span className="path2" />
								<span className="path3" />
								<span className="path4" />
								<span className="path5" />
								<span className="path6" />
								<span className="path7" />
								<span className="path8" />
								<span className="path9" />
								<span className="path10" />
								<span className="path11" />
								<span className="path12" />
								<span className="path13" />
								<span className="path14" />
								<span className="path15" />
								<span className="path16" />
								<span className="path17" />
								<span className="path18" />
							</span>
							<span className="icon-ses mainSpan">
								<span className="path1" />
								<span className="path2" />
								<span className="path3" />
								<span className="path4" />
								<span className="path5" />
							</span>
						</div>
					</div>
				</div>
				<div className="row d-flex justify-content-center">
					{projects &&
						projects.map((e) => (
							<ProjectCard
								difficulty={e.difficulty}
								id={e.id}
								key={e.id}
								main={e.shortDesc}
								title={e.title}
								url={e.url}
								urlTitle={e.urlTitle}
								year={e.year}
								image={e.image}
							/>
						))}
				</div>
			</MainContent>
		);
	}
}

function mapStateToProps(state) {
	return {
		projects: (state.projects && state.projects.data) || [],
	};
}

export default withRouter(
	connect(
		mapStateToProps,
		actions,
	)(Projects),
);



// WEBPACK FOOTER //
// ./src/components/Projects.js